import { useCallback, useContext } from 'react';
import { AuthContext } from './AuthContext';

// Stable fallbacks: a fresh `[]` each render made `can` a new function every
// render, which defeated every effect and callback that depends on it.
const NONE = [];

// What the signed-in user may do in the admin area. Full admins can do
// everything; everyone else is limited to the expanded permission keys and the
// admin tabs the server computed for them (/api/me admin_areas).
export default function useAdminAccess() {
  const ctx = useContext(AuthContext);
  const isFullAdmin = !!ctx?.user?.is_admin;
  const permissions = ctx?.permissions || NONE;
  const areas = ctx?.adminAreas || NONE;
  const can = useCallback(
    (key) => isFullAdmin || permissions.includes(key),
    [isFullAdmin, permissions],
  );
  const canAny = useCallback((keys) => keys.some(can), [can]);
  return { isFullAdmin, areas, hasAdminAccess: isFullAdmin || areas.length > 0, can, canAny };
}
